// eslint-disable-next-line node/no-extraneous-import
import { gql } from '@apollo/client'

const PinsQuery = gql`
  query Pins($databaseId: ID!) {
    category(id: $databaseId, idType: DATABASE_ID) {
      pins {
        uri
        latlon
        title
        image
      }
    }
  }
`

export interface IPin {
  uri: string
  latlon: string
  title: string
  image: string
}

export interface IPinsQueryData {
  category: {
    pins: IPin[]
  }
}

export interface IPinsQueryVariable {
  databaseId: string
}

export default PinsQuery
